import { render, staticRenderFns } from "./CashiersLimitsView.vue?vue&type=template&id=8e1790b4&scoped=true"
import script from "./CashiersLimitsView.vue?vue&type=script&lang=js"
export * from "./CashiersLimitsView.vue?vue&type=script&lang=js"
import style0 from "./CashiersLimitsView.vue?vue&type=style&index=0&id=8e1790b4&prod&lang=scss"
import style1 from "./CashiersLimitsView.vue?vue&type=style&index=1&id=8e1790b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1790b4",
  null
  
)

export default component.exports